
'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/event-stack.production.js');
} else {
  module.exports = require('./cjs/event-stack.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/@semantic-ui-react/event-stack/lib/index.js
// module id = 484
// module chunks = 0